// ── CovenantCalendarPage ──
import { useState, useEffect } from "react";
import { exportCSV, fmtDate, localFilter } from "../../../shared/format";
import { Badge, Btn, Card, ErrorMsg, Icon, Pagination, STh, SearchBar, SectionHeader, Spinner, Td, Th } from "../../../shared/ui";
import { usePagination, useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const CovenantCalendarPage = () => {
    const { api, role, view, setModal, setConfirm, delRec } = useApp();
      const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null); const [q,setQ]=useState("");
      const [cat,setCat]=useState("");
      const load=()=>{setLoading(true);api.get("getCovenantCalendar").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
      useEffect(()=>{load();},[]);
      const categories=[...new Set(rows.map(r=>r.covenantcategory).filter(Boolean))].sort();
      const catFiltered=cat?rows.filter(r=>r.covenantcategory===cat):rows;
      const filtered=localFilter(catFiltered,q,["companyname","covenantcategory","covenantname","status","completedby"]);
      const { sorted, sortKey, sortDir, toggle } = useSortable(filtered, 'duedate');
      const { paginated:displayed, page, setPage, totalPages, total, reset } = usePagination(sorted, 100);
      if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
      return <>
        <SectionHeader actions={[
          <select key="cat" value={cat} onChange={e=>{ setCat(e.target.value); reset(); }}
            style={{ padding:"6px 10px", fontSize:13, borderRadius:6, border:"1px solid var(--color-border-secondary)", background:"var(--color-background-primary)", color:"var(--color-text-primary)" }}>
            <option value="">All Categories</option>
            {categories.map(c=><option key={c} value={c}>{c}</option>)}
          </select>,
          <SearchBar key="s" value={q} onChange={v=>{ setQ(v); reset(); }} placeholder="Search calendar..." />,
          <Btn key="ex" onClick={()=>exportCSV(sorted,["companyname","covenantcategory","covenantname","status","testdate","duedate","completeddate","completedby","covenantvalue"],"covenant_calendar.csv")}>Export CSV</Btn>
        ]} />
        <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
            <thead><tr>
              <STh label="Account" sortKey="companyname" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Category" sortKey="covenantcategory" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Covenant" sortKey="covenantname" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Status" sortKey="status" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Test Date" sortKey="testdate" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Due Date" sortKey="duedate" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Completed" sortKey="completeddate" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="PM" sortKey="completedby" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Value" sortKey="covenantvalue" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <Th></Th>
            </tr></thead>
            <tbody>{displayed.map(e=>(
              <tr key={e.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"covenantcalendar-view",rec:e})} onMouseEnter={ev=>ev.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                <Td style={{ fontWeight:500 }}>{e.companyname}</Td>
                <Td>{e.covenantcategory||"—"}</Td>
                <Td>{e.covenantname||"—"}</Td>
                <Td><Badge s={e.status||"—"} /></Td>
                <Td>{fmtDate(e.testdate)}</Td>
                <Td>{fmtDate(e.duedate)}</Td>
                <Td>{e.completeddate?fmtDate(e.completeddate):"—"}</Td>
                <Td>{e.completedby||"—"}</Td>
                <Td>{e.covenantvalue||"—"}</Td>
                <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={ev=>ev.stopPropagation()}>
                  <Btn onClick={()=>setModal({type:"covenantcalendar-view",rec:e})}><Icon type="view" /></Btn>
                  {role.canEdit&&<Btn onClick={()=>setModal({type:"covenantcalendar-edit",rec:e,onDone:load})}><Icon type="edit" /></Btn>}
                  {role.canDelete&&<Btn variant="danger" onClick={()=>setConfirm({msg:"Delete this calendar entry?",onConfirm:()=>delRec("CovenantCalendar",e.id,"Deleted covenant calendar entry",load)})}><Icon type="delete" /></Btn>}
                </div></Td>
              </tr>
            ))}</tbody>
          </table>
          <Pagination page={page} totalPages={totalPages} total={total} pageSize={100} onPage={setPage} />
        </Card>
      </>;
    };
